import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../Seller/Sidebar';
import PropertyDashboard from '../Seller/PropertyDashboard';
import EditProperties from '../Seller/EditProperties';
import ProfileInbox from '../Commonlibs/ProfileInbox';
import Transactions from '../Seller/Transactions';
import PropertySeeAll from './PropertySeeAll';

const SellerProperties = () => {
  const { propertyId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const propertyFromState = location.state?.property;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [currentView, setCurrentView] = useState(() => {
    if (propertyId) return 'edit';
    if (location.pathname.includes('/inbox')) return 'inbox';
    if (location.pathname.includes('/transactions')) return 'transactions';
    if (location.pathname.includes('/seeAll')) return 'seeAll';
    return 'dashboard';
  });

  const [selectedProperty, setSelectedProperty] = useState(propertyFromState || null);

  useEffect(() => {
    if (propertyId) {
      if (!selectedProperty || selectedProperty.id !== parseInt(propertyId)) {
        const fetchProperty = async () => {
          try {
            const mockProperty = {
              id: parseInt(propertyId),
              price: '₹250,000.00',
              title: 'Modern Luxury Villa with Ocean View',
              location: 'Nanakram guda, Hyderabad, India',
              date: 'May 13, 2025',
              views: '2,500 Views',
              beds: 4,
              baths: 3,
              area: '2,500 sq.ft',
              description: 'This stunning modern villa offers luxurious living with breathtaking ocean views.',
              propertyType: 'Residential duplex Villa',
              propertyID: `#PD0785${propertyId}481`,
              builtYear: '2021'
            };
            setSelectedProperty(mockProperty);
            setCurrentView('edit');
          } catch (error) {
            console.error('Failed to fetch property:', error);
            navigate('/sell-properties');
          }
        };
        fetchProperty();
      } else {
        setCurrentView('edit');
      }
    } else {
      if (location.pathname.includes('/inbox')) {
        setCurrentView('inbox');
      } else if (location.pathname.includes('/transactions')) {
        setCurrentView('transactions');
      } else if (location.pathname.includes('/seeAll')) {
        setCurrentView('seeAll');
      } else {
        setCurrentView('dashboard');
      }
    }
  }, [propertyId, location.pathname, navigate, selectedProperty]);

  const handleEditProperty = (property) => {
    setSelectedProperty(property);
    setCurrentView('edit');
    navigate(`/sell-properties/edit/${property.id}`, {
      state: { property }
    });
  };

  const handleSeeAllProperties = () => {
    setCurrentView('seeAll');
    navigate('/sell-properties/seeAll');
  };

  const handleSidebarNavigation = (itemName) => {
    if (itemName === 'Inbox') {
      setCurrentView('inbox');
      navigate('/sell-properties/inbox');
    } else if (itemName === 'Dashboard') {
      setCurrentView('dashboard');
      navigate('/sell-properties');
    } else if (itemName === 'Transactions') {
      setCurrentView('transactions');
      navigate('/sell-properties/transactions');
    } else if (itemName === 'My Properties') {
      setCurrentView('seeAll');
      navigate('/sell-properties/seeAll');
    } else if (itemName === 'LogOut') {
      navigate('/login');
    } else if (itemName === 'Edit Profile') {
      // Handle edit profile navigation
    }
  };

  const getActiveSidebarItem = () => {
    switch (currentView) {
      case 'inbox':
        return 'Inbox';
      case 'dashboard':
        return 'Dashboard';
      case 'transactions':
        return 'Transactions';
      case 'edit':
        return 'My Properties';
      case 'seeAll':
        return 'My Properties';
      default:
        return 'Dashboard';
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        overflowX: 'hidden',
        background: '#f9fafb',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: '10px', md: 0 },
        mt: { xs: '64px', md: '15px' },
      }}
    >
      {!isMobile && (
        <Box
          sx={{
            flexShrink: 0,
            width: { xs: '100%', md: 'auto' },
          }}
        >
          <Sidebar
            userName="Sai shashank"
            email="Shashanksharna547@gmail.com"
            phoneNumber="+91 7330648804"
            onItemClick={handleSidebarNavigation}
            activeItem={getActiveSidebarItem()}
          />
        </Box>
      )}

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: '10px', md: '20px' },
          margin: { xs: '10px', md: '20px' },
          marginTop: { xs: 0, md: '25px' },
          boxSizing: 'border-box',
          overflowX: 'auto',
        }}
      >
        {currentView === 'dashboard' ? (
          <PropertyDashboard
            onEditProperty={handleEditProperty}
            onSeeAllProperties={handleSeeAllProperties}
          />
        ) : currentView === 'inbox' ? (
          <ProfileInbox />
        ) : currentView === 'transactions' ? (
          <Transactions />
        ) : currentView === 'seeAll' ? (
          <PropertySeeAll onEditProperty={handleEditProperty} />
        ) : (
          <EditProperties
            property={selectedProperty}
            onBack={() => navigate('/sell-properties')}
          />
        )}
      </Box>
    </Box>
  );
};

export default SellerProperties;